import {E2EPatientData} from '../../features/biotwin/types';
import {api} from './api';

export const e2eApi = api.injectEndpoints({
  endpoints: (build) => ({
    getPatientInfo: build.query<E2EPatientData, {patientId: string}>({
      query: (arg) => `/guven/hasta-bilgileri/${arg.patientId}`,
    }),
  }),
});

export const {useLazyGetPatientInfoQuery} = e2eApi;
